/**
 * ISO 7010 pictogram codes supported by the app.
 * Derived from SVGs in public/img/iso-7010-pictograms/ (ISO_7010_<code>.svg).
 * For now only W (Warning) codes are exposed for hazard pictogram selection.
 */
const ALL_ISO_7010_PICTOGRAM_CODES = [
  'E001', 'E002', 'E003', 'E004', 'E007', 'E008', 'E009', 'E010', 'E011', 'E012',
  'E013', 'E014', 'E015', 'E016', 'E017', 'E018', 'E019', 'E020', 'E021', 'E022',
  'E023', 'E024', 'E025', 'E026', 'E027', 'E028', 'E029', 'E030', 'E031', 'E032',
  'E033', 'E034', 'E035', 'E036', 'E037', 'E038', 'E039', 'E040', 'E041', 'E042',
  'E043', 'E044', 'E045', 'E046', 'E047', 'E048', 'E049', 'E050', 'E051', 'E052',
  'E053', 'E054', 'E055', 'E056', 'E057', 'E058', 'E059', 'E060', 'E061', 'E062',
  'E063', 'E064', 'E065', 'E067', 'E068', 'E070', 'E072', 'E073', 'E074', 'E075',
  'E076',
  'F001', 'F002', 'F003', 'F004', 'F005', 'F006', 'F007', 'F008', 'F009', 'F010',
  'F011', 'F012', 'F013', 'F014', 'F015', 'F016', 'F017', 'F018',
  'M001', 'M002', 'M003', 'M004', 'M005', 'M006', 'M007', 'M008', 'M009', 'M010',
  'M011', 'M012', 'M013', 'M014', 'M015', 'M016', 'M017', 'M018', 'M019', 'M020',
  'M021', 'M022', 'M023', 'M024', 'M025', 'M026',
  'P001', 'P002', 'P003', 'P004', 'P005', 'P006', 'P007', 'P008', 'P009', 'P010',
  'P011', 'P012', 'P013', 'P014', 'P015', 'P016', 'P017', 'P018', 'P019', 'P020',
  'P021', 'P022', 'P023', 'P024', 'P025', 'P026', 'P027', 'P028', 'P029', 'P030',
  'P031', 'P032', 'P033', 'P034', 'P035', 'P036', 'P037', 'P038', 'P039', 'P040',
  'P041', 'P042', 'P043', 'P044', 'P045', 'P046', 'P047', 'P048', 'P049', 'P050',
  'P051', 'P052', 'P053', 'P054', 'P055', 'P056', 'P057', 'P058', 'P059', 'P060',
  'P061', 'P062', 'P063', 'P064', 'P065', 'P066',
  'W001', 'W002', 'W003', 'W004', 'W005', 'W006', 'W007', 'W008', 'W009', 'W010',
  'W011', 'W012', 'W013', 'W014', 'W015', 'W016', 'W017', 'W018', 'W019', 'W020',
  'W021', 'W022', 'W023', 'W024', 'W025', 'W026', 'W027', 'W028', 'W029', 'W030',
  'W035', 'W039', 'W068', 'W069', 'W070', 'W071', 'W072', 'W073', 'W074', 'W075',
  'W076', 'W077', 'W078', 'W079',
] as const

/** Pictogram codes shown in the hazard selector. For now only W (Warning) codes. */
export const ISO_7010_PICTOGRAM_CODES: readonly string[] =
  ALL_ISO_7010_PICTOGRAM_CODES.filter((code) => code.startsWith('W'))

export function getIso7010PictogramUrl(code: string): string {
  return `/img/iso-7010-pictograms/ISO_7010_${code}.svg`
}
